import React,{useState, useEffect} from 'react';
import {motion} from 'framer-motion';

import './viewAllProductsAdd.css'
import svgWhatsapp from '../../../assets/whatsapp.svg';

import CodigosAreaPaises from '../../utils/codigosAreaPaises/codigosDeAreaPorPaises';
import svgShoppingCart from '../../../assets/shoppingCart.svg'

import configMessageWhatsappWeb from './configMessageWhatsApp.js'



const ViewAllProductsAdd =({shoppingCart, handleCantidad,remoreProductShoppingCard, TIENDA})=>{

    const [precioTotal, setPrecioTotal] = useState(0);

    const [stateAlert, setStateAlert] =useState(false);
    
    // whatsap controls data
    const [dataUser, setDataUser] =useState({
        nameClient:'',
        phoneNumber:0,
        codigoPais:CodigosAreaPaises[0].codigoPais
    })
    const [pedido, setPedido]= useState(shoppingCart)

    const handleDataUser =(e)=>{
        e.preventDefault();

        setDataUser({
            ...dataUser,
            [e.target.name]:e.target.value
        })
    }

    useEffect(()=>{
       var result = 0;
       if(shoppingCart.length>0){
          shoppingCart.map(product=>result=result + (product.priceCurrent * product.cantidad));
            setPrecioTotal(result)
        }       
    },[shoppingCart])

    
    const sendPedido=()=>{
        // console.log(TIENDA);
        if(/[0-9]{8}/.test(dataUser.phoneNumber) && dataUser.nameClient!=''){
            configMessageWhatsappWeb(TIENDA, dataUser, pedido)
        }else{
            console.log('complete los campos requerido');
            setStateAlert(true);
            setTimeout(()=>{
                setStateAlert(false);
            },5000)
        }
    }


    return (
        <motion.div id="container-cart-view-all" initial={{opacity:0,y:"100%"}} animate={{opacity:1,y:0}} transition={{duration:0.5}}   className="bg-white h-full w-full pt-20 ">
            <div className="bg-white px-0 sm:px-10 text-center mb-4 md:mb-20 text-2xl sm:text-2xl font-bold">CARRITO DE COMPRAS</div>
            <div className=" grid justify-items-center md:flex md:flex-row gap-2 mb-36">

                <div  id="prodcuts-shoping-cart" className="grid grid-cols-1   bg-white h-full w-full md:w-8/12 px-1 md:ml-10">
                {
                    shoppingCart.length>0?
                    <ul className="flex justify-between text-gray-400 font-semibold relative md:border-b border-gray-300 h-auto w-auto my-1  md:mx-10 lg:mx-16">
                    <li className="mx-auto">Producto</li>
                    <li className="mx-auto">Nombre/Precio</li>
                    <li className="mx-auto">Cantidad</li>
                    </ul>
                    :''
                }
                {   
                    
                    shoppingCart.length>0?
                    shoppingCart.map((d,i)=>{
                        return(
                            <motion.div id="item-product"  key={d+i} whileHover={{ scale:1.01 }} className="flex flex-nrow relative border border-gray-400 hover:shadow-xl rounded-lg bg-white h-auto w-auto my-1  md:mx-10 lg:mx-16">
                                <div className="rounded-lg bg-white  w-40 h-24">
                                    <motion.img key={i} initial={{opacity:0}} animate={{opacity:1}} src={d.fotoProducto} className="rounded-lg w-auto h-full m-auto" alt="" />
                                    <div className="top-0 left-0 absolute text-indigo-500 bg-gray-200 px-2 rounded-xl">{i+1}</div>
                                </div>
                                <div id="card-body" className="mx-auto bg-gray-100 px-2 pb-2">
                                    <div className="text-sm font-bold text-green-600 text-left leading-tight py-2">{d.nameProduct.substr(0,35)}</div>
                                    <div className="text-base font-bold text-gray-900">{TIENDA?.country?.currenciesMoneda} {d.priceCurrent}</div>
                                
                                </div>
                                <div className="my-auto mx-2 md:mx-auto">
                                    <div className="flex flex-row justify-between border border-gray-900 rounded-xl w-32 my-auto px-2">
                                        {
                                            d.cantidad >1?
                                            <div onClick={()=>handleCantidad(false,d)} className="text-gray-500 font-bold cursor-pointer p-1 ">-</div>
                                            :
                                            <div className="my-auto text-gray-500">
                                                <svg onClick={()=>remoreProductShoppingCard({item:i})} xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 hover:text-red-400 cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                                                <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                                                </svg>
                                            </div>
                                        }
                                        <div className="text-gray-600 font-bold cursor-pointer p-1 ">{d.cantidad}</div>
                                        <div onClick={()=>handleCantidad(true,d)} className="text-gray-500     font-bold cursor-pointer p-1 ">+</div>
                                    </div>
                                </div>
                            </motion.div>
                        )
                    })
                    :
                    <div className="w-full my-auto">
                        <div className="text-center text-xl font-medium">
                            No hay articulos agregados
                        </div>
                        <div className="text-center">
                            Aun no has añadido nada a tu carrito de compras, empiece a agregar los productos que le gusten.
                        </div>
                        <div className="mx-auto mt-10">
                            <img className="mx-auto" src={svgShoppingCart} alt="" />
                        </div>
                    </div>


                }
                {
                    shoppingCart.length>0?
                    <div className="flex justify-end text-gray-500 font-medium   my-1  pr-2 md:pr-0  md:mx-10 lg:mx-16">
                        <div>Total: {TIENDA?.country?.currenciesMoneda} {precioTotal}</div>
                    </div>
                    :''

                }

                </div>
                {
                    shoppingCart?.length>0?

                
                <div  className="grid justify-items-center w-full md:w-5/12 mx-auto md:mr-10">
                    <div id="content-resumen-pedido"  className="sticky top-10  h-auto my-auto w-11/12  rounded-lg p-2 mt-5 md:mt-0  ">
                   
                    
                        <div className="text-white font-bold text-center mb-3 text-lg">Resumen del pedido</div>
                        <hr className="border border-b-5" />
                        <div className="text-white font-semibold pl-1" >Costo de los Articulos : <span> {TIENDA?.country?.currenciesMoneda} {precioTotal}  </span> </div>
                        <div className="text-white font-semibold pl-1" >Costo de envio :  <span> {TIENDA?.country?.currenciesMoneda} 0  </span></div>
                        <hr className="border border-t-5 mx-0 md:mx-2" />
                        <div className="text-white font-semibold pl-1 mt-2 text-xl"> TOTAL: <span> {TIENDA?.country?.currenciesMoneda} {precioTotal}</span></div>
                       
                        <div className="pt-3">
                            <form>
                                <div className="my-2 flex flex-col">
                                    <label className="text-gray-200 font-normal text-sm" htmlFor="name">Ingresa su nombre y apellido</label>
                                    <input onChange={(e)=>handleDataUser(e)} name="nameClient" id="name" className="rounded-md p-2 focus:outline-none" type="text"  placeholder="Erica Miranda" />
                                </div>
                                <div className="">
                                    <label className="text-gray-200 font-normal text-sm" htmlFor="phone">Ingrese su número de Whatsapp</label>
                                    <div className="flex flex-row bg-white rounded-md">
                                        {/* <img src={svgWhatsapp} alt="" className="ml-1 h-5 w-5 my-auto" /> */}
                                        <select onChange={(e)=>handleDataUser(e)} name="codigoPais" className="bg-white focus:outline-none rounded-lg" name="phone" id="selec-codigo-pais" >
                                            <option value={TIENDA?.callingCodes}>+{TIENDA?.callingCodes}</option>
                                            {
                                                CodigosAreaPaises.map((d,i)=>{
                                                    return <option key={d.slug} value={d.codigoPais}>+{d.codigoPais}</option>
                                                }) 
                                            }
                                        </select>
                                        <input onChange={(e)=>handleDataUser(e)} name="phoneNumber" id="input-number-phone" className="w-full rounded-md p-2 focus:outline-none" type="number" placeholder="69654589" />
                                    </div>
                                </div>
                            </form>
                        </div>
                        {
                            stateAlert?
                            <motion.div initial={{opacity:0,y:100}} animate={{opacity:1,y:0}} className="rounded-lg border border-red-600 px-2 mt-4 bg-red-300 opacity-70 p-2 text-red-700">
                                complete los campos requeridos
                            </motion.div>
                            :
                            <div className="my-14"></div>
                        
                        }
                        <motion.div  whileHover={{scale:1.01}}  whileTap={{scale:0.97}} id="btn-realizar-pedido-whatsapp" onClick={()=>sendPedido()} className=" rounded-full cursor-pointer mb-10">
                            
                            <div className="flex flex-row p-2 mt-1 text-white font-semibold capitalize border  rounded-full border-white-600 shadow-2xl focus:outline-none focus:border-indigo-500 w-auto">
                                
                                <motion.img animate={{scale:[1.02,0.95,1,1.02]}} transition={{duration:2, ease:"easeInOut",times:[0,0.2,0.5,0.8,1],loop:Infinity}} src={svgWhatsapp} alt="" className="ml-auto mr-2 h-6 w-6" />
                                <span className="mr-auto">Realizar Pedido por Whatsapp</span>
                               
                                {/* <svg xmlns="http://www.w3.org/2000/svg" id="box-products" style={{zIndex:'1'}} className="absolute  text-white h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
                                </svg> */}
                            </div>
                        
                        </motion.div>
                    </div>
                </div>
                :''
                }
            </div>
            
        </motion.div>
    )
}

export default ViewAllProductsAdd;